import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import images from "../../Assets/Projects/images22.jpg";
import images2 from "../../Assets/Projects/images.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          `Here are a few projects I've worked on recently.`
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={images2}
              isBlog={false}
              title="Dice Game CI/CD pipeline"
              description="A dice game which uses Github Actions as CI and ArgoCD as CD with several other tools used such as docker, AWS, sonarqube, trivy, terraform, etc."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={images2}
              isBlog={false}
              title="Puddle"
              description="A complete e-com website which has django as backend and react as frontend and postgres as database, fully dockerized and ready to be deployed in a kubernetes cluster."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={images2}
              isBlog={false}
              title="Nutrients Calculator"
              description="Nutrients Calculator developed using Django and jQuery that enables users to calculate calories and nutritional values for various food items. Features include real-time nutrient analysis, dynamic food search, meal tracking, responsive design, and automatic saving of user data and calculation history using Local Storage."             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={images}
              isBlog={false}
              title="Tic-Tac-Toe"
              description="Tic Tac Toe Android application developed using Java and Android Studio. Features include two-player gameplay, real-time move validation, win/draw detection, responsive UI, and game reset functionality for an engaging user experience."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={images}
              isBlog={false}
              title="Ecommerce app"
              description="E-commerce web application developed using the Django framework. Features include product catalog management, category filtering, shopping cart, user authentication, order tracking, admin dashboard, responsive design, and secure checkout functionality for a seamless online shopping experience."
              />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={images}
              isBlog={false}
              title="Quiz App"
              description="Quiz web application developed using Django and JavaScript. Features include category-based quizzes, user authentication, timer-based assessments, real-time score calculation, result tracking, leaderboard functionality, responsive design, and performance analytics."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
